import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AvailableRoutes } from 'src/app/enums/available-routes';
import { ReleaseDto } from 'src/app/models/release/release-dto';
import { ForgeService } from 'src/app/services/forge.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ReleaseRowComponent } from '../../components/release-row/release-row.component';

@Component({
    selector: 'oaibox-releases-page',
    templateUrl: './releases-page.component.html',
    styleUrls: ['./releases-page.component.css'],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        ReleaseRowComponent,
    ],
})
export class ReleasesPageComponent implements OnDestroy {

  protected releases: ReleaseDto[] = [];
  protected shownReleases: ReleaseDto[] = [];
  protected keyword: string = '';

  private releasesSubscription?: Subscription;

  constructor(
    forgeService: ForgeService,
    private router: Router,
  ) {
    this.releasesSubscription = forgeService.getReleases$().subscribe(releases => {
      this.releases = releases ?? [];
      this.filterMatchingReleases();
    });
    forgeService.refreshReleases();
  }

  public filterMatchingReleases(): void {
    if (this.keyword == null) return;

    this.filterReleases();
    this.sortReleases();
  }

  private filterReleases(): void {
    const filterFn = (release: ReleaseDto) => {
      const keyword = this.keyword.trim().toLowerCase();
      return release.name?.toLowerCase().includes(keyword) ||
        release.cn5g?.tagName?.toLowerCase().includes(keyword) ||
        release.flexric?.tagName?.toLowerCase().includes(keyword) ||
        release.gnb?.tagName?.toLowerCase().includes(keyword);
    }
    this.shownReleases = this.keyword.trim() ? this.releases.filter(filterFn) : [...this.releases];
  }

  private sortReleases(): void {
    const sortFn = (a: ReleaseDto, b: ReleaseDto) => {
      if (!a.releaseDate || !b.releaseDate) return 0;
      if (a.releaseDate < b.releaseDate) return 1;
      if (a.releaseDate > b.releaseDate) return -1;
      return 0;
    };
    this.shownReleases.sort(sortFn);
  }

  protected goToNewReleasePage(): void {
    this.router.navigate([AvailableRoutes.NEW_RELEASE]);
  }

  ngOnDestroy(): void {
    this.releasesSubscription?.unsubscribe();
  }
}
